// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICmsReportingRequiredPropertyDto
 */
export interface ICmsReportingRequiredPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof ICmsReportingRequiredPropertyDto
     */
    cms_reporting_required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICmsReportingRequiredPropertyDto
     */
    cms_reporting_required_state?: ICmsReportingRequiredPropertyDtoCmsReportingRequiredStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICmsReportingRequiredPropertyDtoCmsReportingRequiredStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ICmsReportingRequiredPropertyDto interface.
 */
export function instanceOfICmsReportingRequiredPropertyDto(value: object): value is ICmsReportingRequiredPropertyDto {
    return true;
}

export function ICmsReportingRequiredPropertyDtoFromJSON(json: any): ICmsReportingRequiredPropertyDto {
    return ICmsReportingRequiredPropertyDtoFromJSONTyped(json, false);
}

export function ICmsReportingRequiredPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICmsReportingRequiredPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cms_reporting_required': json['cms_reporting_required'] == null ? undefined : json['cms_reporting_required'],
        'cms_reporting_required_state': json['cms_reporting_required_state'] == null ? undefined : json['cms_reporting_required_state'],
    };
}

export function ICmsReportingRequiredPropertyDtoToJSON(json: any): ICmsReportingRequiredPropertyDto {
    return ICmsReportingRequiredPropertyDtoToJSONTyped(json, false);
}

export function ICmsReportingRequiredPropertyDtoToJSONTyped(value?: ICmsReportingRequiredPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cms_reporting_required': value['cms_reporting_required'],
        'cms_reporting_required_state': value['cms_reporting_required_state'],
    };
}

